import React, { useState, useEffect } from 'react';

// Import your custom asset icons
import handcraftedIcon from '../assets/icon/handcraft.png'; 
import premiumIcon from '../assets/icon/premium.png';
import customIcon from '../assets/icon/custom.png';
import globalIcon from '../assets/icon/global.png';
import { getPublicRequest } from '../api/auth.js';
import API_ROUTES from '../components/config/apiConfig';

export default function Hero({ onNavigate }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideData, setSlideData] = useState([]);

 // Auto slider

 useEffect(() => {
  fetchBanners();
}, []);
useEffect(() => {
  if (slideData.length <= 1) return;

  const slideInterval = setInterval(() => {
    setCurrentSlide((prev) =>
      prev === slideData.length - 1 ? 0 : prev + 1
    );
  }, 7000);

  return () => clearInterval(slideInterval);
}, [slideData]);

 const handleNext = () => {
  setCurrentSlide((prev) =>
    prev === slideData.length - 1 ? 0 : prev + 1
  );
};

  const fetchBanners = async () => {
  try {
    const res = await getPublicRequest(API_ROUTES.GET_BANNERS);

    const banners = Array.isArray(res.data)
      ? res.data
      : res.data?.data || [];

    const activeBanners = banners
      .filter(item => item.status === true)
      .map(item => ({
        id: item._id,
        title: item.title,
        bgImage: `${item.imageUrl}?w=1600&h=900&fit=crop&q=80`,
      }));

    setSlideData(activeBanners);
  } catch (err) {
    console.error('Banner Error:', err);
  }
};

const handlePrev = () => {
  setCurrentSlide((prev) =>
    prev === 0 ? slideData.length - 1 : prev - 1
  );
};

  return (
    <section className="hero-slider-wrapper">
      
      {/* MEDIA WINDOW: Holds images and controls together securely */}
      <div className="hero-media-window">
        {slideData.map((slide, index) => (
          <div 
            key={slide.id}
            className={`hero-slide-pane ${index === currentSlide ? 'active-pane' : ''}`}
            style={{ background: `url(${slide.bgImage}) no-repeat center center/cover` }}
          />
        ))}
        <div className="hero-overlay-tint"></div>
        
        {/* Controls dock inside the image window container */}
        <div className="hero-carousel-controls-dock">
          <button className="carousel-arrow-btn" onClick={handlePrev} aria-label="Previous Slide">‹</button>
          <button className="carousel-arrow-btn" onClick={handleNext} aria-label="Next Slide">›</button>
          <span className="carousel-index-counter">0{currentSlide + 1} / 0{slideData.length}</span>
        </div>
      </div>

      {/* CONTENT AREA: Follows below fluidly on mobile, overlays cleanly on desktop */}
      <div className="container hero-layout-container">
        <div className="hero-left-content-stack">
          <h1 className="hero-main-title">
            Timeless Elegance.<br />
            <span>Handcrafted Brilliance.</span>
          </h1>
          
          <p className="hero-description-txt">
            Premium handcrafted lamps that blend traditional artistry with modern aesthetics for every space & occasion.
          </p>
          
          <div className="hero-horizontal-badges-row">
            <div className="hero-badge-column">
              <img src={handcraftedIcon} alt="" className="hero-badge-vector" />
              <span>Handcrafted by Artisans</span>
            </div>
            <div className="hero-badge-divider"></div>
            
            <div className="hero-badge-column">
              <img src={premiumIcon} alt="" className="hero-badge-vector" />
              <span>Premium Quality</span>
            </div>
            <div className="hero-badge-divider"></div>
            
            <div className="hero-badge-column">
              <img src={customIcon} alt="" className="hero-badge-vector" />
              <span>Custom Solutions</span>
            </div>
            <div className="hero-badge-divider"></div>
            
            <div className="hero-badge-column">
              <img src={globalIcon} alt="" className="hero-badge-vector" />
              <span>Global Delivery</span>
            </div>
          </div>

          {/* <div className="hero-action-buttons-wrapper">
            <a 
              href="/lightingale-catalogue.pdf" 
              download="Lightingale_Creative_Catalogue_2026.pdf"
              className="btn-outline-catalogue"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Download Catalogue
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
}